/**
 * How a client reaches the Beatly team from an upsell or "order" prompt: an
 * email to the team's account manager when the session knows one, else the
 * public contact page (opened in a new tab).
 */

export const SALES_CONTACT_FALLBACK_URL = 'https://beatly.com/contact';

export interface SalesContactLink {
  href: string;
  /** True for the public contact page (open in a new tab); false for mailto. */
  external: boolean;
}

export function salesContactLink(
  accountManagerEmail: string | null | undefined,
  message?: { subject?: string; body?: string },
): SalesContactLink {
  const email = accountManagerEmail?.trim();
  if (!email) return { href: SALES_CONTACT_FALLBACK_URL, external: true };
  const query = [
    message?.subject ? `subject=${encodeURIComponent(message.subject)}` : '',
    message?.body ? `body=${encodeURIComponent(message.body)}` : '',
  ]
    .filter(Boolean)
    .join('&');
  return { href: `mailto:${email}${query ? `?${query}` : ''}`, external: false };
}
